var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"mb-4 h3"},[_vm._v(_vm._s(_vm.title))]),_c('results',{attrs:{"hasPagination":true,"type":null,"limit":10}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }